













import Vue from 'vue'
import Component from 'vue-class-component';

/**
 * Campo de texto para selección de fichero
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class FileSelectorField extends Vue {

}
